import { styled } from '@mui/material/styles';
import FolderOffOutlinedIcon from '@mui/icons-material/FolderOffOutlined';

const EmptyFolderIcon = styled(FolderOffOutlinedIcon)(({ theme }) => ({
    fontSize: 200,
    color: theme.palette.grey[300],
}));

export default EmptyFolderIcon;